var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconZeroBalanceAccount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28296_23872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3918 14.1727L22.6227 11.1418C22.5385 10.9977 22.4002 10.8927 22.2385 10.851C22.0777 10.811 21.9052 10.8343 21.7618 10.9202L16.3535 14.1652L24.3918 14.1727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.0013C12.0417 15.0013 11.6667 14.6263 11.6667 14.168C11.6667 13.7096 12.0417 13.3346 12.5 13.3346H15.3083L18.0917 11.668H12.5C11.2667 11.668 10.2417 12.568 10.0417 13.7513C10.025 13.818 10 13.8846 10 13.9596V26.668C10 28.043 11.125 29.168 12.5 29.168H26.6667C27.5833 29.168 28.3333 28.418 28.3333 27.5013V25.8346H26.25C24.1833 25.8346 22.5 24.1513 22.5 22.0846C22.5 20.018 24.1833 18.3346 26.25 18.3346H28.3333V16.668C28.3333 15.7513 27.5833 15.0013 26.6667 15.0013H12.5ZM25.8333 13.3346C25.8333 12.493 25.2083 11.793 24.3917 11.6846L25.8333 14.168V13.3346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.375 19.582H26.25C24.8717 19.582 23.75 20.7037 23.75 22.082C23.75 23.4604 24.8717 24.582 26.25 24.582H29.375C29.72 24.582 30 24.302 30 23.957V20.207C30 19.862 29.72 19.582 29.375 19.582ZM26.25 22.9154C25.79 22.9154 25.4167 22.542 25.4167 22.082C25.4167 21.622 25.79 21.2487 26.25 21.2487C26.71 21.2487 27.0833 21.622 27.0833 22.082C27.0833 22.542 26.71 22.9154 26.25 22.9154Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28296_23872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconZeroBalanceAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_zero_balance_account.62d1343908263b8d2782eb73fd4b62f3.svg";